import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Search icon
 *
 * @file Search.jsx
 * @author Sam George
 */
const Search = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M17.9097583,16.4457485 L22.6967936,21.2327838 C23.1010688,21.637059
      23.1010688,22.2925185 22.6967936,22.6967936 C22.2925185,23.1010688
      21.637059,23.1010688 21.2327838,22.6967936 L16.4457485,17.9097583
      C14.8180853,19.2175068 12.7504232,20 10.5,20 C5.25329488,20 1,15.7467051
      1,10.5 C1,5.25329488 5.25329488,1 10.5,1 C15.7467051,1 20,5.25329488
      20,10.5 C20,12.7504232 19.2175068,14.8180853 17.9097583,16.4457485
      L17.9097583,16.4457485 Z M10.5,17.9 C14.5869071,17.9 17.9,14.5869071
      17.9,10.5 C17.9,6.41309285 14.5869071,3.1 10.5,3.1 C6.41309285,3.1
      3.1,6.41309285 3.1,10.5 C3.1,14.5869071 6.41309285,17.9 10.5,17.9 Z"
    />
  </SvgIcon>
);

export default Search;
